.row {
	grid-area: chips;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	width: 100%;
}

.chip {
	display: flex;
	align-items: center;
	gap: 8px;
	max-width: 240px;
	padding: 8px 10px;
	background: var(--parrot-chat-surface-raised);
	border: 1px solid var(--parrot-chat-border);
	border-radius: var(--parrot-chat-radius-lg);
	font-size: var(--parrot-chat-font-size-sm);
	color: var(--parrot-chat-text-secondary);
}

.icon {
	display: flex;
	align-items: center;
	flex-shrink: 0;
	color: var(--parrot-chat-text-muted);
}

.icon svg {
	width: 18px;
	height: 18px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

.spinner {
	animation: chipspin 0.8s linear infinite;
}

.spinner circle {
	opacity: 0.35;
	stroke-dasharray: 42;
	stroke-dashoffset: 30;
}

.name {
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.remove {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	flex-shrink: 0;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: 50%;
	color: var(--parrot-chat-text-muted);
	cursor: pointer;
	opacity: 0;
	transition: opacity 0.12s, color 0.12s, background 0.12s;
}

.chip:hover .remove,
.remove:focus-visible {
	opacity: 1;
}

.remove:hover {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-menu-hover);
}

.remove svg {
	width: 14px;
	height: 14px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

.chip[data-status="error"] {
	border-color: var(--parrot-chat-error);
	color: var(--parrot-chat-error);
}

@keyframes chipspin {
	to {
		transform: rotate(360deg);
	}
}
